export default __webpack_public_path__ + "981a39b30609ca44c08ed4f185d40bb4.png";